import * as actions from '../utils/Constants';
import { apiGet, apiRequest, Methods } from '../utils/Api';


export const searchCourses = (searchTerm) => {
    return {
        type: actions.SEARCH_COURSES,
        payload: searchTerm.trim() ? apiGet(`${process.env.REACT_APP_API_HOST}api/courses/${searchTerm}`) : []
    }
}

export const searchTrainingCourses = (trainingId, searchTerm) => {
    return {
        type: actions.SEARCH_COURSES,
        payload: searchTerm.trim() ? apiGet(`${process.env.REACT_APP_API_HOST}api/training/${trainingId}/courses/${searchTerm}`) : []
    }
}

export const clearSearchedCourses = () => {
    return {
        type: actions.CLEAR_SEARCHED_COURSES
    }
};

export const searchTrainingPrograms = (trainingId) => {
    return {
        type: actions.SEARCH_PROGRAMS,
        payload: apiGet(`${process.env.REACT_APP_API_HOST}api/training/${trainingId}/programSearch`)
    }
}

export const searchUnassignedSections = (sessionId, searchTerm) => {
    return dispatch => dispatch({
        type: actions.SEARCH_COURSES,
        payload: searchTerm.trim() ? apiRequest(`${process.env.REACT_APP_API_HOST}api/session/${sessionId}/sections/${searchTerm}`, Methods.get, null, dispatch) : []
    });
};